import { render, staticRenderFns } from "./peopleRadioDialog.vue?vue&type=template&id=1167af2f&lang=pug&"
import script from "./peopleRadioDialog.vue?vue&type=script&lang=js&"
export * from "./peopleRadioDialog.vue?vue&type=script&lang=js&"
import style0 from "./peopleRadioDialog.vue?vue&type=style&index=0&id=1167af2f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports